import pallete from '../../assets/stacklogo/pallete.svg'

export default function PalleteLogo(){
    return(
        <img src={pallete} alt="" srcset="" />
    )
}